import { LayoutProps } from '../LayoutProps';
import styles from './FullscreenLayout.module.css';

/**
 * Jeu en PLEIN ÉCRAN, sans aucun chrome console (ni bandeau ni QR flottant).
 * Pensé pour le tutoriel d'onboarding : le jeu affiche LUI-MÊME le QR de
 * session dans sa scène d'accueil (via API.getSessionLink() transmis par le
 * bridge WebView) et gère sa propre sortie (« Passer le tutoriel » / CTA).
 */
export function FullscreenLayout({ children }: LayoutProps) {
    return (
        <div className={styles.container}>
            <div className={styles.game}>{children}</div>
        </div>
    );
}
